import { defineMessages } from 'react-intl';

const I18N_NAMESPACE = 'FormComponent';

export default defineMessages({
  emailPlaceholder: {
    id: `${I18N_NAMESPACE}.emailPlaceholder`,
    defaultMessage: 'Your e-mail address',
  },
  emailLabel: {
    id: `${I18N_NAMESPACE}.emailLabel`,
    defaultMessage: 'Email',
  },
  invalidPhoneNumber: {
    id: `${I18N_NAMESPACE}.invalidPhoneNumber`,
    defaultMessage: 'Invalid phone number',
  },
  phoneNumberRequired: {
    id: `${I18N_NAMESPACE}.phoneNumberRequired`,
    defaultMessage: 'Please specify your phone number',
  },
  phoneNumberPlaceholder: {
    id: `${I18N_NAMESPACE}.phoneNumberPlaceholder`,
    defaultMessage: 'Your phone number',
  },
  unableToValidate: {
    id: `${I18N_NAMESPACE}.unableToValidate`,
    defaultMessage:
      'We could not validate your phone number, please try again.',
  },
  selectMarket: {
    id: `${I18N_NAMESPACE}.selectMarket`,
    defaultMessage: 'Select your market',
  },
  addressRequired: {
    id: `${I18N_NAMESPACE}.addressRequired`,
    defaultMessage: 'Please select an address',
  },

  addressPlaceholder: {
    id: `${I18N_NAMESPACE}.addressPlaceholder`,
    defaultMessage: 'Installation address',
  },
  validatingAddress: {
    id: `${I18N_NAMESPACE}.validatingAddress`,
    defaultMessage: 'Validating address...',
  },
  loadingSuggestions: {
    id: `${I18N_NAMESPACE}.loadingSuggestions`,
    defaultMessage: 'Loading address suggestions...',
  },

  // Common form fields
  firstNameLabel: {
    id: `${I18N_NAMESPACE}.firstNameLabel`,
    defaultMessage: 'First name',
  },
  firstNamePlaceholder: {
    id: `${I18N_NAMESPACE}.firstNamePlaceholder`,
    defaultMessage: 'Your first name',
  },
  lastNameLabel: {
    id: `${I18N_NAMESPACE}.lastNameLabel`,
    defaultMessage: 'Last name',
  },
  lastNamePlaceholder: {
    id: `${I18N_NAMESPACE}.lastNamePlaceholder`,
    defaultMessage: 'Your last name',
  },
  addressLabel: {
    id: `${I18N_NAMESPACE}.addressLabel`,
    defaultMessage: 'Address',
  },
});
